import { isEmpty } from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Row, Col } from 'reactstrap'

const UserDefaultAddress = ({
  history,
  user,
  defaultAddress,
  supplier,
}) => {
  const goToUserAddress = () => {
    window.analytics.track(`Go to user addresses`)
    history.push(`/mis-direcciones`)
  }

  return (
    <React.Fragment>
      <div
        className="cart-card"
        onClick={goToUserAddress}
        style={{ cursor: 'pointer' }}
      >
        <Row>
          <h3 className="cart-card-title">Dirección de envío</h3>
        </Row>
        <div className="cart-card-arrow-right">
          <i className="fa fa-chevron-right font-size-24"></i>
        </div>
        <Row style={{ marginBottom: '10px' }}>
          <Col sm="12"
            className="cart-card-font"
            style={{ alignSelf: 'center' }}
          >
            <div className="cart-user-address-card-subtitle">
              {user.firstName} {user.lastName}
            </div>
          </Col>
        </Row>
        <Row style={{ marginBottom: '10px' }}>
          <Col sm="12"
            className="cart-card-font"
            style={{ alignSelf: 'center', fontWeight: 300 }}
          >
            {isEmpty(defaultAddress) ? `Sin dirección de envío seleccionada` : `${defaultAddress.calle} 
              ${defaultAddress.numeroExterior} 
              ${defaultAddress.numeroInterior} 
              ${defaultAddress.colonia} 
              ${defaultAddress.cp} 
              ${defaultAddress.localidad} 
              ${defaultAddress.municipio} 
              ${defaultAddress.state && defaultAddress.state.nomEstado} 
              ${defaultAddress.country && defaultAddress.country.nameEs}`
            }
          </Col>
        </Row>
        <Row>
          <Col
            className="text-left cart-card-font" 
            style={{ alignSelf: 'center' }}
          >
            Entrega estimada:
          </Col>
          <Col className="text-left cart-card-font" style={{ alignSelf: 'center' }}>
            <div className="cart-summary-card-profit">
              {supplier && supplier.tiempoEntregaEstandar} días hábiles
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  return { user: state.Login.user }
}

export default withRouter(connect(mapStatetoProps, {})(UserDefaultAddress))
